<manage-wrapper
  *ngIf="!!exhibitor && { brief: exhibitorBriefs[exhibitor?.id] } as e"
  [canEditMain]="!readOnly"
  [topToggleText]="'EXHIBITOR ' + (exhibitor.confirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
  [topToggled]="!!exhibitor.confirmed"
  [topSecondToggleText]="'SHOW IN PUBLISH'"
  [topSecondToggled]="!exhibitor.hideInPublish"
  [entityTitle]="exhibitor.name"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readOnly"
  [labels]="exhibitor.labels"
  [labelMap]="labelMap"
  [labelList]="labels"
  [clipLabel]="readOnly ? '' : clipLabel"
  [deleteTitle]="'Delete exhibitor: ' + exhibitor.name || 'Unnamed exhibitor'"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [titlePlaceholder]="'Exhibitor name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Exhibitor'"
  [type]="'exhibitor'"
  [showStars]="true"
  [stars]="exhibitor.stars || 0"
  (saveStars)="saveStars($event)"
  (onToggle)="toggleExhibitorConfirmed()"
  (onSecondToggle)="toggleHideInPublish()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="deleteExhibitor($event)"
  (onDuplicate)="duplicateExhibitor()"
  (saveTitle)="updateExhibitorName($event)"
  (onClip)="clip()"
>

  <entity-types class="afterTitle"
    [readOnly]="readOnly"
    [entityType]="'exhibitor'"
    [entity]="exhibitor"
  ></entity-types>
  
  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.info">

    <div class="toggle-holder">
      <div style="flex:1;"></div>
      <toggle-tab class="inner-toggle" [bottomTab]="false" [hideToggle]="readOnly" [text]="'DETAILS ' + (exhibitor.detailsConfirmed ? '' : 'NOT ') + 'CONFIRMED'" [toggled]="!!exhibitor.detailsConfirmed" (toggle)="toggleDetailsConfirmed()"></toggle-tab>
    </div>
    <ng-container *ngIf="!readOnly">
      <tip-text class="ex-profile" *ngIf="exhibitorShareable?.status == 'Active'" [type]="'warn'" [head]="'Attention:'" [body]="'This exhibitor has an active webform to edit profile information.'"></tip-text>
      <tip-text class="ex-profile" *ngIf="!exhibitorShareable || exhibitorShareable.status != 'Active'" [type]="'tip'" [head]="'Tip:'" [body]="'Exhibitors can submit their profile information using a shareable link by turning on the <strong>Profile webform for editing</strong> below.'"></tip-text>
    </ng-container>
    <ng-container *ngIf="!readOnly">
      <div>Share webform to receive exhibitor profile information.</div>
      <binary-share-toggle
        [type]="'profile'"
        [shareType]="shareTypes.exhibitor"
        [hideBottom]="!exhibitorShareable"
        [shareableFormat]="'oneLine'"
        [shareCode]="exhibitorShareable?.code"
        [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
        [title]="'Profile webform'"
        [shareTitle]="'Your shareable webform:'"
        [generatingCode]="generatingEditCode"
        [status]="exhibitorShareable?.status || 'Off'"
        (toggle)="toggleExhibitorProfile()"
        (changeStatus)="changeExhibitorProfileStatus($event)"
      ></binary-share-toggle>
    </ng-container>

    <image-uploader 
        [id]="exhibitor?.id"
        (newUrls)="changeLogo($event)"
        [immediate]="true" 
        [isLogo]="true"
        [displayType]="imageUploaderDisplayTypes.widePodLogo"
        [thumbUrl]="exhibitor.logoUrl" 
        [photoUrl]="exhibitor.fullLogoUrl"
        [eventId]="event?.eventId"
        [saveName]="exhibitor.name"
        [type]="'exhibitor'" 
        [subtype]="'logo'" 
        [placeholder]="'Add logo'" 
        [uploadText]="'UPLOAD LOGO'"
    ></image-uploader>

    <h3 class="description-title">Description</h3>
    <!--<joi-input class="description" [disabled]="readOnly" [italicPlaceholder]="true" [(model)]="exhibitor.description" [type]="'textarea'" [returnable]="true" [placeholder]="'Click to add a description...'" (joiChange)="saveExhibitor()"></joi-input>
-->
    <input-editor 
      [disabled]="readOnly"
      [object]="exhibitor" 
      [prop]="'description'" 
      [placeholder]="'Click to add a description...'"
      (changed)="saveExhibitor()"
    ></input-editor>

    <manage-social [links]="exhibitor?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>

    <manage-call-to-action
      [entity]="exhibitor"
      [ctaProp]="'callToAction'"
      [urlProp]="'callToActionUrl'"
      [readOnly]="readOnly"
      (ctaDetailsChanged)="saveExhibitor()"
    ></manage-call-to-action>

    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="exhibitor"
      [entityName]="'Exhibitor'"
      [nameProp]="'contactName'"
      [numberProp]="'contactNumber'"
      [emailProp]="'contactEmail'"
      [readOnly]="readOnly"
      (contactDetailsChanged)="saveExhibitor()"
    ></manage-contact-details>

    <custom-questions-app
      [entity]="exhibitor"
      [entityType]="'exhibitor'"
      (updateQuestion)="updateCustomQuestion($event)"
    ></custom-questions-app>

    <ng-container *ngIf="!readOnly">
      <div>Share webform to receive exhibitor profile information.</div>
      <binary-share-toggle
        [type]="'profile'"
        [shareType]="shareTypes.exhibitor"
        [hideBottom]="!exhibitorShareable"
        [shareableFormat]="'oneLine'"
        [shareCode]="exhibitorShareable?.code"
        [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
        [title]="'Profile webform'"
        [shareTitle]="'Your shareable webform:'"
        [generatingCode]="generatingEditCode"
        [status]="exhibitorShareable?.status || 'Off'"
        (toggle)="toggleExhibitorProfile()"
        (changeStatus)="changeExhibitorProfileStatus($event)"
      ></binary-share-toggle>
    </ng-container>

  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.contact">
    <tip-text class="top" [type]="'tip'" [head]="'Tip:'" [body]="'The workforce contact will appear in the exhibitor brief.'"></tip-text>
    <manage-contact
      [workforceContactEmail]="exhibitor?.workforceContactEmail"
      [readOnly]="readOnly"
      (changeContact)="changeWorkforceContact($event)"
    ></manage-contact>
  </ng-container>


  <ng-container *ngIf="selectedTab?.id === tabs.details">
    <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: false}"></ng-container>
    <ng-container [ngTemplateOutlet]="exhibitorStandsTemplate" [ngTemplateOutletContext]="{mobile: true}"></ng-container>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
    <chat-box [isNotes]="true" [comments]="exhibitor?.quickNotes || []" [readOnly]="!event || event.is_readonly" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
  </ng-container>

  <entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="exhibitor" [changeDetectorRef]="changeDetectorRef"></entity-tasks>

  <ng-container *ngIf="selectedTab?.id === tabs.briefInfo">
    <tip-text class="top" [head]="'Tip:'" [body]="'Information added here will only appear in <strong>'+exhibitor.name+'&rsquo;s</strong> exhibitor brief.'"></tip-text>
    <title-icon [titleIcon]="'description18'" [title]="'Information for '+exhibitor.name+' only'"></title-icon>
    <div class="empty-text">Add information or instructions specific to this exhibitor</div>
    <informable 
      [singleSectionOnly]="true"
      [informableType]="'exhibitor'" 
      [informableKey]="data.exhibitorId" 
      [noItemsMessage]="''"
      ></informable>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.configBrief">
    <h3 style="padding: 20px 0 ; ">Configure actions to include in {{ exhibitor.name }}'s exhibitor brief</h3>
    <tip-text class="top" [type]="'important'" [head]="'Important'" [body]="'Actions will automatically appear in '+ exhibitor.name +'\'s Exhibitor Brief when the below configurations are set to &ldquo;ON&rdquo;'"></tip-text>
    <h5>PROFILE</h5>
    <add-link-to-brief-wrapper
      style="margin-top: 10px; display: block;"
      [title]="'<strong>Include profile webform</strong>'"
      [toggleOn] = "exhibitor.showEditProfileLinkInBrief"
      [selected] = "exhibitorShareable?.status || 'Off'"
      (toggle)="updateShowEditProfileLinkInBrief()"
      (toggleStatus)="changeExhibitorProfileStatus($event)"
    ></add-link-to-brief-wrapper>

    <edit-associated-assets-manager *ngIf="!!exhibitor" style="margin-top: 30px;"
      [type]="'exhibitor'"
      [entity]="exhibitor"
      [view]="'actions'"
      (toggleShowEditAssetsLinkInBrief)="exhibitor.showAssetsLinkInBrief = $event; saveExhibitor()"
    ></edit-associated-assets-manager>

    <h5 style="margin-top: 30px;">EXHIBITOR STANDS</h5>
    <grey-wrapper *ngFor="let stand of standIds | idsToItems:stands" class="sessions" >
      <big-and-grey 
        *ngIf="{ program: programs[stand.programId]?.title || '', type: standTypes[stand.standTypeId]?.name || '' } as vars"
        class="wideContent" 
        [theTitle]="stand.name" 
        [greyText]="vars.program + ( vars.program && vars.type ? ' | ' : '' ) + vars.type" 
      ></big-and-grey>
      <add-link-to-brief-wrapper
        [title]="'Receive <strong>requests</strong> from '+ exhibitor?.name + ' for this stand'"
        [toggleOn] = "!!eRequest[stand.id+'_'+exhibitor?.id] && eRequest[stand.id+'_'+exhibitor?.id].status !== 'Off'"
        [disabled] = "readOnly"
        [selected] = "eRequest[stand.id+'_'+exhibitor?.id]?.status || 'Off'"
        (toggle)="setStandItemStatus(stand.id, $event ? 'Active' : 'Off', 'eRequest')"
        (toggleStatus)="setStandItemStatus(stand.id, $event, 'eRequest')"
      ></add-link-to-brief-wrapper>
    </grey-wrapper>
    
    <ng-container *ngIf="!!briefActions?.standAssets.length">
      <h5 class="subtitle">EXHIBITOR STAND ASSETS</h5>
      <add-link-to-brief-wrapper *ngFor="let sa of briefActions.standAssets"
        style="margin-top: 10px; display: block;"
        [title]="sa.name"
        [titleIcon]="sa.icon"
        [toggleOn]="false"
        [statusOn]="true"
        [dimmed]="false"
        [disabled]="readOnly"
        [sessions]="sa.sessions"
        [selected]="sa.status"
        (toggleStatus)="setAssetStatus($event, sa)"
      ></add-link-to-brief-wrapper>
    </ng-container>
  
    <manage-terms [type]="'exhibitor'" [entity]="exhibitor" [readOnly]="readOnly" (saveEntity)="saveExhibitor()"></manage-terms>
  </ng-container>
  
  <ng-container *ngIf="selectedTab?.id === tabs.assets">
    <assets 
      [title]="'Associated Assets'"
      [associatedId]="exhibitor.id"
      [assetIds]="associatedAssetIds"
      [entityHolderName]="'exhibitor'"
      [readOnly]="readOnly"
    ></assets>

    <ng-container *ngIf="!readOnly">
      <edit-associated-assets-manager *ngIf="!!exhibitor" style="margin-top: 30px;"
        [type]="'exhibitor'"
        [entity]="exhibitor"
        [view]="'shareable'"
      ></edit-associated-assets-manager>
    </ng-container>

  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.schedule">
    <app-brief *ngIf="!!event && !!exhibitor"
      [exhibitor]="exhibitor"
      [briefType]="'exhibitor'"
      [briefInfo]="e.brief"
      [timelineOnly]="true"
    ></app-brief>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.preview">
      <binary-share-toggle
        class="brief"
        [type]="'brief'"
        [contactName]="exhibitor.contactName || ''"
        [contactEmail]="exhibitor.contactEmail || ''"
        [shareType]="shareTypes.exhibitorBrief"
        [shareableFormat]="'oneLine'"
        [shareCode]="e.brief?.id"
        [hint]="'Note: The shareable webpage below is dynamic and will always load the current information for the exhibitor.'"
        [title]="'Exhibitor Brief webpage'"
        [shareTitle]="'Your shareable webpage:'"
        [status]="e.brief?.status || 'Off'"
        [alwaysOnMessage]="'Share the exhibitor brief as a webpage.'"
        (toggle)="shareUrl($event)"
        (changeStatus)="shareUrl($event === 'Off' ? false : true)"
      ></binary-share-toggle>
      <tip-text class="top" class="brief-tip bottom" [type]="'tip'" [head]="'Tip:'" [body]="'Below is what <strong>' + exhibitor.name + '</strong> will see when they view their brief.\n\nAn exhibitor’s brief is built automatically from other sections of Joi — for example, you can include a program in the <strong>Set Up</strong> section. Assigning an exhibitor to a room/location or tagging them to an activity in <strong>On Site Schedule</strong> will populate the <strong>My Schedule</strong> section.'"></tip-text>
  
      <hr class="big-rule" />
      <app-brief *ngIf="!!event && !!exhibitor"
        [exhibitor]="exhibitor"
        [briefType]="'exhibitor'"
        [briefInfo]="e.brief"
      ></app-brief>
  </ng-container>
</manage-wrapper>

<ng-template #exhibitorStandsTemplate let-mobile="mobile">
  <exhibitor-stands [ngClass]="{ mobile: mobile, fullScreen: !mobile }"
    [showBriefStatus]="true"
    [displayType]="mobile ? exhibitorDisplayTypes.narrowPod : exhibitorDisplayTypes.widePod"
    [readOnly]="readOnly"
    [exhibitorId]="exhibitor?.id"
    [emptyText]="'No exhibitor stands exist'"
  ></exhibitor-stands>
</ng-template>


